var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10781IconServiceBlobPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7fa1637-d9e1-4c26-8f20-1cae812e7eeb",
    x1: 9,
    y1: 15.834,
    x2: 9,
    y2: 5.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#32d4f5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MsPortalFx.base.images-8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b1d9b0f0-adfa-47cc-8819-3fbc616212eb"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.5,5.788h17a0,0,0,0,1,0,0v9.478a.568.568,0,0,1-.568.568H1.068A.568.568,0,0,1,.5,15.266V5.788A0,0,0,0,1,.5,5.788Z",
    fill: "url(#b7fa1637-d9e1-4c26-8f20-1cae812e7eeb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.071,2.166H16.929a.568.568,0,0,1,.568.568V5.788a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V2.734A.568.568,0,0,1,1.071,2.166Z",
    fill: "#198ab3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.818,6.945H9.737a.243.243,0,0,0-.243.243v6.646a.243.243,0,0,0,.243.243h5.34a.243.243,0,0,0,.244-.243v-4.4a.244.244,0,0,0-.244-.244H13.305a.243.243,0,0,1-.243-.244V7.188A.243.243,0,0,0,12.818,6.945Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.706,7.256V8.925a.613.613,0,0,0,.612.612H15v4.229H9.815V7.256h2.891m.118-.365H9.7a.247.247,0,0,0-.247.247v6.746a.247.247,0,0,0,.247.247h5.42a.247.247,0,0,0,.247-.247V9.419a.248.248,0,0,0-.247-.247h-1.8a.247.247,0,0,1-.247-.247V7.138a.247.247,0,0,0-.247-.247Z",
    fill: "#c3f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.27,9.221,12.986,6.945V8.8a.418.418,0,0,0,.416.421Z",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.251,6.945H3.169a.243.243,0,0,0-.243.243v6.646a.243.243,0,0,0,.243.243H8.51a.243.243,0,0,0,.243-.243v-4.4a.243.243,0,0,0-.243-.244H6.737a.243.243,0,0,1-.243-.244V7.188A.243.243,0,0,0,6.251,6.945Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.138,7.256V8.925a.613.613,0,0,0,.612.612H8.432v4.229H3.248V7.256h2.89m.118-.365H3.13a.246.246,0,0,0-.247.247v6.746a.246.246,0,0,0,.247.247H8.549a.246.246,0,0,0,.247-.247V9.419a.247.247,0,0,0-.247-.247H6.75A.248.248,0,0,1,6.5,8.925V7.138a.246.246,0,0,0-.247-.247Z",
    fill: "#c3f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,9.221,6.418,6.945V8.8a.418.418,0,0,0,.416.421Z",
    fill: "#50e6ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10781IconServiceBlobPage);
export default __webpack_public_path__ + "static/media/10781-icon-service-Blob-Page.ecc2e195acf6ac577e8712ada1b80823.svg";
export { ForwardRef as ReactComponent };